import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
@Component({
  selector: "app-person-import-management-jica-saiken",
  templateUrl: "./import-management-jica-saiken.component.html",
  styleUrls: ["./import-management-jica-saiken.component.css"],
})
export class PersonImportManagementJicaSaikenComponent {
  @Input() import_history_list: any[] = [];

  // 親から渡される状態（クリア処理など）を内部状態に反映
  @Input() set file_selected(val: boolean) {
    this.internal_file_selected = val;
    if (!val) this.selected_file_name = "";
  }

  @Output() onImport = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onErrorClick = new EventEmitter<any>();
  @Output() onReload = new EventEmitter<void>();
  @Output() onFileSelect = new EventEmitter<any>();

  internal_file_selected: boolean = false;
  selected_file_name: string = "";
  selectInputFile: any;

  // ファイル選択時のイベントハンドラ
  selectedFile(files: FileList) {
    if (files && files.length > 0) {
      this.internal_file_selected = true;
      this.selected_file_name = files[0].name;
      // 親コンポーネントへ通知（実際のアップロード処理用）
      this.onFileSelect.emit(files);
    } else {
      this.internal_file_selected = false;
      this.selected_file_name = "";
    }
  }

  // 状態判定関数 (Angular 5 パースエラー対策済)
  getBadgeClass(h: any): string {
    if (!h) return "badge-soft-secondary";
    return h.import_result == 1
      ? "badge-soft-success"
      : h.import_result == 9
        ? "badge-soft-secondary"
        : "badge-soft-danger";
  }

  getStatusLabel(h: any): string {
    if (!h) return "";
    return h.import_result == 1
      ? "完了"
      : h.import_result == 9
        ? "削除"
        : "エラー";
  }

  importSaiken(files: FileList) {
    if (files && files.length > 0) this.onImport.emit(files);
  }
  reload() {
    this.onReload.emit();
  }
  delpersons(h: any) {
    this.onDelete.emit(h);
  }
  showerror(h: any) {
    this.onErrorClick.emit(h);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/import-management/jica/saiken/import-management-jica-saiken.component.ts